import { baseApi } from '@/shared/api/baseApi';
import type { AttachmentDto } from '../model/types';

const attachmentApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    listAttachments: builder.query<AttachmentDto[], string>({
      query: (documentId) => `documents/${documentId}/attachments`,
      providesTags: (_result, _error, documentId) => [{ type: 'Document', id: documentId }],
    }),
    uploadAttachment: builder.mutation<AttachmentDto, { documentId: string; file: File }>({
      query: ({ documentId, file }) => {
        const formData = new FormData();
        formData.append('file', file);
        return { url: `documents/${documentId}/attachments`, method: 'POST', body: formData };
      },
      invalidatesTags: (_r, _e, { documentId }) => [{ type: 'Document', id: documentId }],
    }),
    updateAttachment: builder.mutation<AttachmentDto, { id: string; documentId: string; visibleToClient: boolean }>({
      query: ({ id, visibleToClient }) => ({ url: `attachments/${id}`, method: 'PATCH', body: { visibleToClient } }),
      invalidatesTags: (_r, _e, { documentId }) => [{ type: 'Document', id: documentId }],
    }),
    deleteAttachment: builder.mutation<void, { id: string; documentId: string }>({
      query: ({ id }) => ({ url: `attachments/${id}`, method: 'DELETE' }),
      invalidatesTags: (_r, _e, { documentId }) => [{ type: 'Document', id: documentId }],
    }),
    downloadAttachment: builder.query<Blob, string>({
      query: (id) => ({ url: `attachments/${id}/download`, responseHandler: (response: Response) => response.blob() }),
    }),
  }),
});

export const {
  useListAttachmentsQuery,
  useUploadAttachmentMutation,
  useUpdateAttachmentMutation,
  useDeleteAttachmentMutation,
  useLazyDownloadAttachmentQuery,
} = attachmentApi;

export { attachmentApi };
